import {useContext} from "react";
import {WindowsContext} from "../context/WindowsContext";

export function useWindows() : {addWindow : (path: string) => void, popWindow : () => void, setMountedWindows : (paths: string[]) => void, isComponentMounted: (path: string) => boolean, mountedWindows: string[]}{
    const windowsHelpers = useContext(WindowsContext);
    return windowsHelpers;
}